import { Language } from "@constants/language";

export const getFlagByLanguage = (lang: Language): string => {
  switch (lang) {
    case Language.PT:
      return "🇧🇷";
    case Language.EN:
      return "🇺🇸";
    case Language.ES:
      return "🇪🇸";
    default:
      return "🏳️";
  }
};
